import { render, staticRenderFns } from "./PickUpOptIn.vue?vue&type=template&id=39f465c5&"
import script from "./PickUpOptIn.vue?vue&type=script&lang=js&"
export * from "./PickUpOptIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JVolke\\Documents\\plentyDevTool\\38722\\18\\KrauseSohn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f465c5')) {
      api.createRecord('39f465c5', component.options)
    } else {
      api.reload('39f465c5', component.options)
    }
    module.hot.accept("./PickUpOptIn.vue?vue&type=template&id=39f465c5&", function () {
      api.rerender('39f465c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/checkout/PickUpOptIn.vue"
export default component.exports